import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import InfoPill from "../../common/InfoPill/InfoPill";
import "./ListingInfoCard.css";
export default function ListingInfoCard({
  listing
}) {
  useLanguage();
  const communityValue = Array.isArray(listing.nationality) ? listing.nationality.join(", ") : listing.nationality;
  const minimumStayValue = listing.minimumStay !== null && listing.minimumStay !== undefined && listing.minimumStay !== "" ? `${listing.minimumStay} month${Number(listing.minimumStay) > 1 ? "s" : ""}` : "Not specified";
  const postedValue = listing.postedDate ? t("Posted on {0}{1}", {0: t(listing.postedDate), 1: listing.postedAgo ? ` • ${t(listing.postedAgo)}` : ""}) : listing.postedAgo ? t("Posted {0}", {0:t(listing.postedAgo)}) : t("Not specified");
  return <Card className="bb-listing-info-card">
      <Card.Body>
        <h3 className="bb-listing-info-card__title">{t("Listing Information")}</h3>

        <Row className="g-3">
          <Col md={6} xl={4}>
            <InfoPill label={t("City")} value={listing.city || "Not specified"} />
          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("District")} value={listing.district || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Rent")} value={`SAR ${listing.price} / month`} />
          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("House Type")} value={listing.houseType || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Room Type")} value={listing.type || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Furnished")} value={listing.furnished || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Gender Preference")} value={listing.gender || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Availability")} value={listing.availability || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Posted")} value={postedValue} />
          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Total Bedrooms")} value={listing.bedrooms !== null && listing.bedrooms !== undefined ? String(listing.bedrooms) : "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Total Bathrooms")} value={listing.bathrooms !== null && listing.bathrooms !== undefined ? String(listing.bathrooms) : "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Current Occupants")} value={listing.currentOccupants !== null && listing.currentOccupants !== undefined ? String(listing.currentOccupants) : "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Kitchen Access")} value={listing.kitchenAccess || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("AC Type")} value={listing.acType || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Electricity Included")} value={listing.electricityIncluded || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Water Bill Included")} value={listing.waterBillIncluded || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Parking Available")} value={listing.parkingAvailable || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Rent Payment Plan")} value={listing.rentPaymentPlan || "Not specified"} />

          </Col>

          <Col md={6} xl={4}>
            <InfoPill label={t("Minimum Stay")} value={minimumStayValue} />

          </Col>

          <Col md={12}>
            <InfoPill label={t("Community Preference")} value={communityValue || "Not specified"} />

          </Col>
        </Row>
      </Card.Body>
    </Card>;
}
